import { isArray } from "lodash-es";
import { CHANGE_RISK_PROFILE } from "../../strings/mf";
import {
  INVESTMENT_FLOW_MAPPER,
  RISK_PROFILE_ENABLED_FLOWS,
  SIP_FLOWS,
  SIP_KEYS,
} from "../../constants/mf";
import {
  formatAmountInr,
  numDifferentiationWithNoSpace,
} from "../common/functions";
import { getGoalMinMaxAmount, getTargetAmountCorpusValue } from "./functions";

export const isRiskProfilerFlow = (data) => {
  return isArray(data);
};

export const isRiskTypeCustom = (riskType = "") => {
  return riskType === CHANGE_RISK_PROFILE.CUSTOM_OPTION_DATA.value;
};

export const isRiskProfileEnabledFlow = (flow = "") => {
  return RISK_PROFILE_ENABLED_FLOWS.includes(flow);
};

export const isCustomRiskFlow = (mfRecommendations = {}) => {
  return mfRecommendations.custom_rp;
};

export const isSipFlow = (investType) => {
  return SIP_KEYS.includes(investType);
};

export const isSaveTaxFlow = (flow) => {
  return flow === INVESTMENT_FLOW_MAPPER.savetax;
};

export const isSaveTaxSipFlow = (flow) => {
  return flow === SIP_FLOWS.savetaxsip;
};

export const isParkMoneyFlow = (flow) => {
  return flow === INVESTMENT_FLOW_MAPPER.investsurplus;
};

export const isSaveForGoalFlow = (flow) => {
  return flow === INVESTMENT_FLOW_MAPPER.saveforgoal;
};

export const isMfInvestmentAllowed = (kyc = {}) => {
  return kyc.kyc_allow_investment_status === "INVESTMENT_ALLOWED";
};

export const isSaveForGoalOthersFlow = (subtype = "") => {
  return subtype === "other";
};

export const validateAmount = (
  amount,
  mfRecommendations,
  investType,
  isCorpusAmountValidation = false
) => {
  const goalData = getGoalMinMaxAmount(mfRecommendations.goal, investType);
  let minValue = goalData.minValue;
  let maxValue = goalData.maxValue;

  if (isCorpusAmountValidation) {
    minValue = getTargetAmountCorpusValue(minValue, mfRecommendations);
    maxValue = getTargetAmountCorpusValue(maxValue, mfRecommendations);
  }

  let formatedMaxValue = maxValue;

  if (formatedMaxValue > 1000) {
    formatedMaxValue = Math.floor(formatedMaxValue / 1000) * 1000;
  }

  let validation = {
    error: false,
    message: "",
    formatedMaxValue,
  };

  if (!amount) {
    validation.error = true;
    validation.message = "Please enter amount";
  } else if (amount > maxValue) {
    validation.error = true;
    validation.message = `Max amount allowed is ${numDifferentiationWithNoSpace(
      maxValue
    )}`;
  } else if (amount < minValue) {
    validation.error = true;
    validation.message = `Min. amount is ${formatAmountInr(minValue)}`;
  } else {
    validation.error = false;
    validation.message = `Min. ${formatAmountInr(minValue)}`;
  }

  return validation;
};

export const isNfoFlow = (flow) => {
  return flow === INVESTMENT_FLOW_MAPPER.nfo;
};
